import React, { Component } from 'react';

/**
 * @file A standard React error boundary component.
 * This component catches JavaScript errors anywhere in its child component tree,
 * logs those errors, and displays a fallback UI.
 */

/**
 * A class component that catches JavaScript errors in its child component tree.
 *
 * @extends React.Component
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          textAlign: 'center',
          padding: '20px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }}>
          <h2>Something went wrong.</h2>
          <p>We're having trouble loading the app, which can sometimes happen on mobile browsers after a period of inactivity.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              border: '1px solid #ccc',
              borderRadius: '5px',
              backgroundColor: '#f0f0f0'
            }}
          >
            Refresh Session
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
